import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import {IconoirLayoutLeft} from '@ey-xd/motif-icon';

import Module from '..';

const DashboardModule = ({onClick}) => {
	const props = {
		icon: IconoirLayoutLeft,
		label: labels.dashboard,
		onClick
	};

	return <Module {...props} />;
};

DashboardModule.propTypes = {};

DashboardModule.defaultProps = {};

export default DashboardModule;
